var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.videos),function(video){return _c('VideoItemDetail',{key:video.etag,attrs:{"video":video},on:{"video-select":_vm.onVideoSelect}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }